import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15f0c05e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0c05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f0c05e')) {
      api.createRecord('15f0c05e', component.options)
    } else {
      api.reload('15f0c05e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15f0c05e&scoped=true&", function () {
      api.rerender('15f0c05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/gaoda/index.vue"
export default component.exports